/** A member's avatar: their photo, or the robo-cat with their LED colour. */
import { useState } from 'react';
import { DEFAULT_EYE_COLOR, RoboCat, RoboCatColorContext } from './RoboCat.tsx';
import './avatar.css';

export function Avatar({
  url,
  eyeColor,
  name,
  size = 40,
}: {
  url: string | null | undefined;
  eyeColor: string | null | undefined;
  name: string;
  size?: number;
}) {
  const [broken, setBroken] = useState<string | null>(null);
  const photo = url && broken !== url ? url : null;
  return (
    <span className="avatar" style={{ width: size, height: size }}>
      {photo ? (
        <img src={photo} alt="" width={size} height={size} loading="lazy" decoding="async" onError={() => setBroken(photo)} />
      ) : (
        <RoboCatColorContext.Provider value={eyeColor || DEFAULT_EYE_COLOR}>
          {/* RoboCat draws itself 1.2× larger than asked; this keeps it inside the circle. */}
          <RoboCat size={Math.round(size * 0.7)} label={`Аватар: ${name}`} />
        </RoboCatColorContext.Provider>
      )}
    </span>
  );
}
